import styled from "styled-components";

export const ItemPerPageWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-right: 28px;
 `;
